import {DataTable, FormDialog} from '@management-ui/core';
import {makeStyles} from '@mui/styles';
import * as React from 'react';
import {useCallback, useMemo, useRef, useState} from 'react';

const useStyles = makeStyles((theme) => ({
  deleteButton: {
    '&.MuiButton-root': {
      backgroundColor: theme.palette.grey[500],
      color: theme.palette.common.white,

      '&:hover': {
        backgroundColor: theme.palette.grey[700],
      },
    }
  },
}));

const ManagementTable = (
  {
    title,
    addTitle = undefined,
    editTitle = undefined,
    columns,
    loadData,
    renderForm,
    onDelete = undefined,
    onRestore = undefined,
    tableProps = {}
  }
) => {
  const classes = useStyles();
  /** @type {({current: DataTable})} */
  const tableRef = useRef();
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleSaved = useCallback(() => {
    tableRef.current?.refresh();
    setShowForm(false);
  }, []);

  const handleSelect = useCallback(template => {
    if (editTitle) {
      setSelected(template);
      setShowForm(true);
    } else if (onRestore) {
      onRestore(template).then(() => handleSaved()).catch(() => null);
    }
  }, [editTitle, onRestore, handleSaved]);

  return (
    <>
      <DataTable
        ref={tableRef}
        title={title}
        actions={useMemo(() => addTitle ? {
          after: [
            {
              icon: 'add',
              tooltip: addTitle,
              isFreeAction: true,
              onClick: () => handleSelect(null)
            }
          ]
        } : undefined, [addTitle, handleSelect])}
        columns={columns}
        loadData={useCallback(query => new Promise((resolve, reject) => {
          loadData(query)
            .then(response => {
              resolve({
                data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
              });
            }).catch(() => {
            reject();
          });
        }), [loadData])}
        onRowClick={handleSelect}
        {...tableProps}
      />
      <FormDialog
        title={selected ? editTitle : addTitle}
        open={showForm}
        maxWidth="md"
        onClose={() => setShowForm(false)}
        render={(props) => renderForm(props, selected, handleSaved)}
        additionalButtons={useMemo(() => onDelete && selected ? [{
          label: 'Delete',
          classes: classes.deleteButton,
          onClick: () => {
            if (onDelete) {
              onDelete(selected).then(() => handleSaved()).catch(() => null);
            }
          }
        }] : [], [onDelete, selected, classes, handleSaved])}
      />
    </>
  );
};

export default ManagementTable;
